import { SnakeCaseObject } from '@client/core/data/concerns/parses-from-json';
import { isObject } from '@client/core/utils/is-object';
import { snakeCase } from '@client/core/utils/snake-case';

/**
 * Convert an object to have snake_case keys.
 */
export function snakeCaseKeys<T extends Record<string, any>>(obj: T): SnakeCaseObject<T> {
  const snakeCasedObject = {};

  Object.keys(obj).forEach((key) => {
    snakeCasedObject[snakeCase(key)] = isObject(obj[key]) ? snakeCaseKeys(obj[key]) : obj[key];
  });

  return snakeCasedObject;
}
